let log = {
    title: "操作记录",
    columns: {
        logTime: "操作时间",
      appUsername: "登录账户",
        actionType: "操作类型",
        descp: "操作内容",
        device: "设备类型",
        actionObject:"操作对象",
        browser: "浏览器",
        location: "登录位置",
        ip: "客户端 IP",
      resultReason:'结果原因',
        result: "操作结果"
    },
    type: "操作类型",
    result: "操作结果",
    time: "操作时间",
    startTime:"操作开始时间",
    endTime:"操作结束时间",
    selectType: {
        type01: '全部',
        type02: '登录',
        type03: '登出',
        type04: '绑定',
        type05: '修改',
        type06: '重置',
        type07: '解绑',
        type08: '激活',
        type09: '访问',
        type10: '发送',
        type11: '添加',
        type12: '取消',
        type13:"删除",
        // type14:"ActionId2000",
        type15:"认证",
        type16:"推送认证",
        type17:"绑定",
        type18:"解绑",
        type19:"同步",
        type20:"启用",
        type21:"停用",
        type22:"扫码认证",
    },
    resultType: {
        label01: "全部",
        label02: "失败",
        label03: "成功",
    },
    details: "操作记录详情"
}

export default log
